// TODO: Should this constant be treated as "local" and be moved to the component that uses it?
// TODO: Should this constant be rename to `TEAM_MAP_LEGEND`?
const MAP_LEGEND = {
    PIN_MOVER_TYPE: 'mover',
    PIN_REFINANCED_TYPE: 'refi',
    PIN_PREVIOUS_CUSTOMER_TYPE: 'prev',
    PIN_UNQUALIFIED_TYPE: 'grey',
    PIN_BLACK_TYPE: 'black',
    PIN_RED_CROSS_TYPE: 'redcross',
    WEEKS_SINCE_KNOCKED_OPTIONS_LABELS: [
        'Unknocked / Cleared',
        '0-2 weeks',
        '3-5 weeks',
        '6-8 weeks',
        '9+ weeks',
    ],
    WEEKS_SINCE_KNOCKED_OPTIONS_KEYS: [
        'Cleared',
        '0-2',
        '3-5',
        '6-8',
        '9+',
    ],
    QUALIFIED_ADDRESS_CHOROPLETH_SCALE: [
        {
            legend: '1',
            color: '#FF0000',
            fillColor: '#FF0000',
            fillOpacity: 0.4,
            weight: 0.5,
        },
        {
            legend: '2',
            color: '#FF4100',
            fillColor: '#FF4100',
            fillOpacity: 0.4,
            weight: 0.5,
        },
        {
            legend: '3',
            color: '#FF6000',
            fillColor: '#FF6000',
            fillOpacity: 0.4,
            weight: 0.5,
        },
        {
            legend: '4',
            color: '#FF7B00',
            fillColor: '#FF7B00',
            fillOpacity: 0.4,
            weight: 0.5,
        },
        {
            legend: '5',
            color: '#FF9300',
            fillColor: '#FF9300',
            fillOpacity: 0.4,
            weight: 0.5,
        },
        {
            legend: '6',
            color: '#FFAA00',
            fillColor: '#FFAA00',
            fillOpacity: 0.4,
            weight: 0.5,
        },
        {
            legend: '7',
            color: '#FFC000',
            fillColor: '#FFC000',
            fillOpacity: 0.4,
            weight: 0.5,
        },
        {
            legend: '8',
            color: '#FFD600',
            fillColor: '#FFD600',
            fillOpacity: 0.4,
            weight: 0.5,
        },
        {
            legend: '9',
            color: '#FFEB00',
            fillColor: '#FFEB00',
            fillOpacity: 0.4,
            weight: 0.5,
        },
        {
            legend: '10',
            color: '#FFFF00',
            fillColor: '#FFFF00',
            fillOpacity: 0.4,
            weight: 0.5,
        },
    ],
    WEEKS_SINCE_KNOCKED_CHOROPLETH_SCALE: [
        {
            legend: 'Unknocked',
            color: '#2B8BC3',
            fillColor: '#2B8BC3',
            fillOpacity: 0.4,
            weight: 0.5,
        },
        {
            legend: '0-2 weeks',
            color: '#0000FF',
            fillColor: '#0000FF',
            fillOpacity: 0.4,
            weight: 0.5,
        },
        {
            legend: '3-5 weeks',
            color: '#FFA500',
            fillColor: '#FFA500',
            fillOpacity: 0.4,
            weight: 0.5,
        },
        {
            legend: '6-8 weeks',
            color: '#008000',
            fillColor: '#008000',
            fillOpacity: 0.4,
            weight: 0.5,
        },
        {
            legend: '9+ weeks',
            color: '#FF0000',
            fillColor: '#FF0000',
            fillOpacity: 0.4,
            weight: 0.5,
        },
    ],
    QUALIFIED_AREAS_CHOROPLETH_SCALE: [
        {
            legend: '1',
            quartile: 1,
            fillColor: '#56BBF2',
            fillOpacity: 0.6,
            color: '#FFFFFF',
            weight: 0.4,
        },
        {
            legend: '2',
            quartile: 2,
            fillColor: '#56BBF2',
            fillOpacity: 0.6,
            color: '#FFFFFF',
            weight: 0.4,
        },
        {
            legend: '3',
            quartile: 3,
            fillColor: '#FF7F50',
            fillOpacity: 0.6,
            color: '#FFFFFF',
            weight: 0.4,
        },
        {
            legend: '4',
            quartile: 4,
            fillColor: '#FC0F00',
            fillOpacity: 0.6,
            color: '#FFFFFF',
            weight: 0.4,
        },
        {
            legend: 'Unqualified',
            quartile: 0,
            fillColor: '#808080',
            fillOpacity: 0.6,
            color: '#FFFFFF',
            weight: 0.4,
        },
    ],
    TEAM_PINS: [
        {
            legend: 'Qualified address',
            isQualified: true,
            stroke: '#1C64F2',
            fill: '#56BBF2',
        },
        {
            legend: 'Unqualified address',
            isQualified: false,
            stroke: '#333333',
            fill: '#ABABAB',
        },
        {
            legend: 'Sold',
            isQualified: true,
            stroke: '#2A870E',
            fill: '#68CB4A',
        },
    ],
    OUTCOME_PINS: [
        {
            legend: 'Qualified',
            color: 'blue',
            stroke: '#1C64F2',
            fill: '#56BBF2',
        },
        {
            legend: 'Come back later',
            color: 'purple',
            stroke: '#57378E',
            fill: '#805BBF',
        },
        {
            legend: 'Sold',
            color: 'green',
            stroke: '#44952B',
            fill: '#68CB4A',
        },
        {
            legend: '2nd Knock',
            color: 'yellow-2',
            stroke: '#9F580A',
            fill: '#EF840F',
        },
        {
            legend: '3rd Knock',
            color: 'yellow-3',
            stroke: '#EF840F',
            fill: '#9F580A',
        },
        {
            legend: 'Not Home',
            color: 'yellow',
            stroke: '#C27803',
            fill: '#FCE96A',
        },
        {
            legend: 'Other',
            color: 'red',
            stroke: '#DF2517',
            fill: '#EE675D',
        },
        {
            legend: 'Commercial',
            color: 'pink',
            stroke: '#E9318E',
            fill: '#F17EB8',
        },
        {
            color: 'grey',
            stroke: '#818181',
            fill: '#ABABAB',
        },
    ],
    OUTCOME_PIN_TYPES: [
        {
            name: 'Default',
            type: null,
            hasNote: false,
        },
        {
            name: 'Note added',
            type: null,
            hasNote: true,
        },
        {
            name: 'Unqualified address',
            type: 'grey',
            hasNote: false,
        },
    ],
    QUALIFIED_AREAS_PINS: [
        {
            legend: '1',
            quartile: 1,
            stroke: '#1C64F2',
            fill: '#56BBF2',
        },
        {
            legend: '2',
            quartile: 2,
            stroke: '#1C64F2',
            fill: '#56BBF2',
        },
        {
            legend: '3',
            quartile: 3,
            stroke: '#FF7F50',
            fill: '#FFB296',
        },
        {
            legend: '4',
            quartile: 4,
            stroke: '#870900',
            fill: '#FC0F00',
        },
        {
            legend: 'Unqualified',
            quartile: 0,
            stroke: '#333333',
            fill: '#ABABAB',
        },
    ],
    POLYGONS: [
        {
            legend: 'Deactivated',
            color: '#4A4A4A',
        },
        {
            legend: 'Assigned',
            color: '#008B33',
        },
        {
            legend: 'Unassigned',
            color: '#8430B7',
        },
    ],
};
export default MAP_LEGEND;
